import I18n from "./I18n/i18n";
import "./I18n/ja";
document.addEventListener("turbolinks:load", () => (window.I18n = I18n));
